import React from "react";

export default function DepositTable({ details }) {
  return (
    <tr>
      <th scope="row">{details.planName}</th>
      <td>{details.amount}</td>
      <td>{details.status}</td>
      <td>{details.paymentType}</td>

      <td>
        {" "}
        <a
          style={{
            background: "#00aaef",
            paddingLeft: "30px",
            paddingRight: "30px",
            paddingTop: "10px",
            paddingBottom: "10px",
            borderRadius: "26px",
            color: "white",
            cursor: "pointer",
          }}
        >
          View
        </a>
      </td>
    </tr>
  );
}
